// extracted by mini-css-extract-plugin
module.exports = {"column":"style_column__78NkP","hasSide":"style_hasSide__8KcBo"};